import { Component, inject, Input, OnInit, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { RialToTomanPipe } from '@shared/pipes/rial-to-toman.pipe';
import { Router } from '@angular/router';

export declare var L: any;

@Component({
 selector: 'iho-pdp-ecolodge-map',
 standalone: true,
 imports: [CommonModule, SharedModule],
 templateUrl: './pdp-ecolodge-map.component.html',
 styleUrls: ['./pdp-ecolodge-map.component.scss'],
})
export class PdpEcolodgeMapComponent implements OnInit {
 map: any;
 @Input() houseId: any;
 @Input() isHotel?: boolean;
 @Input() cityName?: string;
 @Input() accommodationType?: any;
 @ViewChild('neshanMap', { static: true }) neshanMap!: any;
 platformId = inject(PLATFORM_ID);
 renderer = inject(Renderer2);
 router = inject(Router);
 _dataSource: any;
 set dataSource(value: any) {
  if (value) {
   this._dataSource = value;
  }
 }
 @Input() get dataSource() {
  return this._dataSource;
 }
 ngOnInit(): void {
  this.initMap(this.dataSource);
 }
 initMap(dataSource: any) {
  this.map = new L.Map('map-ecolodge', {
   key: process.env['IHO_NESHAN_API_KEY'],
   maptype: 'neshan',
   poi: false,
   traffic: false,
   center: [
    dataSource.Address.Lat ? dataSource.Address.Lat : 32,
    dataSource.Address.Long ? dataSource.Address.Long : 26,
   ],
   zoom: 14,
   zoomControl: false,
  });
  const marker = new L.marker(
   [
    dataSource.Address.Lat ? dataSource.Address.Lat : 32,
    dataSource.Address.Long ? dataSource.Address.Long : 26,
   ],
   {
    icon: new L.Icon({
     iconUrl: 'assets/images/leaflet-marker-hotel.svg',
     iconSize: [82, 98],
     iconAnchor: [40, 5],
     riseOnHover: true,
    }),
   }
  );
  this.renderer.addClass(
   document.querySelector('.leaflet-control-container')?.nextSibling,
   'hidden'
  );

  if (this.map) marker.addTo(this.map);
  marker.on('click', this.handleMarkertClickEvent.bind(this));
 }
 handleMarkertClickEvent() {
  this.router.navigate([`ecolodge/${this.cityName}/map`], {
   queryParams: {
    houseId: this.houseId,
    ishotel: this.isHotel,
    AccomodationType: this.accommodationType,
   },
  });
 }
}
